export const newConvocatoria = () => ({
  title: '', slug: '', status: 'draft', starts_at: '', ends_at: '',
  branding: { primary_color: '#003965', secondary_color: '#E42313' },
  settings: { etapa1: { partes: ['formulario', 'chat'] } }, form_schema: null,
});

const APPLICATION_PARTS = ['formulario', 'chat', 'pitch'];

export const getApplicationParts = (settings) => {
  const configured = settings?.etapa1?.partes;
  // Match the public API fallback for existing prizes without explicit parts.
  if (!Array.isArray(configured)) return [...APPLICATION_PARTS];
  return APPLICATION_PARTS.filter(part => part === 'formulario' || configured.includes(part));
};

export const setChatEnabled = (settings, enabled) => {
  const parts = getApplicationParts(settings);
  return {
    ...settings,
    etapa1: {
      ...settings?.etapa1,
      partes: APPLICATION_PARTS.filter(part => part === 'chat' ? enabled : parts.includes(part)),
    },
  };
};

export const slugify = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 100).replace(/-$/, '');

export const availableCopySlug = (sourceSlug, existingSlugs = []) => {
  const used = new Set(existingSlugs);
  const base = slugify(sourceSlug) || 'premio';
  let number = 1;
  while (true) {
    const suffix = number === 1 ? '-copia' : `-copia-${number}`;
    const candidate = `${base.slice(0, 100 - suffix.length).replace(/-$/, '')}${suffix}`;
    if (!used.has(candidate)) return candidate;
    number += 1;
  }
};

export const toLocalDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const fromApi = (value) => ({
  ...value,
  branding: value.branding || {}, settings: value.settings || {},
  starts_at: toLocalDateTime(value.starts_at), ends_at: toLocalDateTime(value.ends_at),
  originalDates: { starts_at: value.starts_at, ends_at: value.ends_at },
});

export const buildPayload = (value, includeForm) => {
  if (!value.title.trim()) throw new Error('Escribe el nombre del premio.');
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value.slug)) {
    throw new Error('El enlace debe contener letras minúsculas, números y guiones entre palabras.');
  }
  const actualDate = (key) => value.originalDates?.[key] && value[key] === toLocalDateTime(value.originalDates[key]) ? value.originalDates[key] : value[key];
  const start = new Date(actualDate('starts_at'));
  const end = new Date(actualDate('ends_at'));
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start >= end) {
    throw new Error('La fecha de término debe ser posterior a la fecha de inicio.');
  }
  const payload = {
    title: value.title.trim(), slug: value.slug, status: value.status,
    starts_at: start.toISOString(), ends_at: end.toISOString(),
    branding: value.branding, settings: value.settings,
  };
  if (value.journey_definition_id !== undefined) payload.journey_definition_id = value.journey_definition_id;
  if (includeForm && value.form_schema) {
    payload.form_schema = { nombre: value.form_schema.nombre, pasos: value.form_schema.pasos };
  }
  return payload;
};

export const apiErrorMessage = (error) => {
  const detail = error?.data?.detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join(' · ');
  if (typeof detail === 'string') return detail;
  return error?.message || (typeof error === 'string' ? error : 'No fue posible guardar los cambios. Intenta nuevamente.');
};

// Modify only the requested path; unknown configuration keys must survive editing.
export const setConfigValue = (config, path, value) => {
  const [key, ...rest] = path.split('.');
  return { ...config, [key]: rest.length ? setConfigValue(config?.[key] || {}, rest.join('.'), value) : value };
};

export const getConfigValue = (config, path) => path.split('.').reduce((value, key) => value?.[key], config);
